import { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import ReactInputVerificationCode from 'react-input-verification-code'

import { TypeMargin } from '@/core/types'
import { cn } from '@bem-react/classname'

import { useTimer } from '@/hooks/useTimer'

import { Message } from '@/components/UI/Message'

import { declensionWithNumber } from '@/utils/declensionWithNumber'

import './VerifyCode.scss'

const cnVerifyCode = cn('VerifyCode')

export interface VerifyCodeProps {
  className?: string
  errors?: string
  value?: string
  autoFocus?: boolean
  length?: number
  type?: 'text' | 'password'
  passwordMask?: string
  onChange?: (value: string) => void
  onCompleted?: () => void
  onResend?: () => void
  mb?: TypeMargin
  placeholder?: string
}

export const VerifyCode: FC<VerifyCodeProps> = ({
  className,
  errors,
  value,
  autoFocus,
  length = 6,
  type,
  passwordMask = '•',
  onChange,
  onCompleted,
  // onResend,
  mb = 'md',
  placeholder = '•',
}): JSX.Element => {
  const { t } = useTranslation()
  const {
    seconds,
    start,
    // pause, reset, isActive
  } = useTimer(180)

  // const [visible, setVisible] = useState<boolean>(false)

  useEffect(() => {
    start()
  }, [])

  return (
    <div
      className={cnVerifyCode(
        {
          xxl: mb === 'xxl',
          xl: mb === 'xl',
          lg: mb === 'lg',
          md: mb === 'md',
          sm: mb === 'sm',
          none: mb === 'none',
          error: !!errors,
        },
        [className],
      )}
    >
      <ReactInputVerificationCode
        placeholder={placeholder}
        value={value}
        autoFocus={autoFocus}
        type={type}
        length={length}
        passwordMask={passwordMask}
        onChange={onChange}
        onCompleted={onCompleted}
      />

      <Message
        className={cnVerifyCode('error')}
        text={errors}
        type='error'
        open={!!errors}
      />

      <div className={cnVerifyCode('timer')}>
        {t('resend-code-after', {
          seconds: declensionWithNumber(seconds, [
            'second',
            'seconds',
            'seconds',
          ]),
        })}
      </div>
    </div>
  )
}
